var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBoosts(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "30px",
    viewBox: "0 0 18 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icBoosts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.5209986%",
    y1: "-38.7165093%",
    x2: "68%",
    y2: "123.599123%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A78",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.94495463,29.9288022 C6.35133003,30.0984312 6.82382467,29.95681 7.06118198,29.5906576 L17.8610596,12.83284 C18.0359576,12.5616094 18.0465175,12.2191289 17.8882992,11.9393436 C17.7300811,11.6586795 17.4277445,11.4844216 17.0999082,11.4844216 L9.8920699,11.4844216 L12.5727195,1.09521925 C12.6808383,0.675512092 12.4619608,0.242035398 12.0550454,0.0712345649 C11.65077,-0.0986873616 11.1752753,0.0437540878 10.938818,0.409379199 L0.138940443,17.1671968 C-0.0359575751,17.4384273 -0.0465174554,17.7809079 0.111700751,18.0606931 C0.269918958,18.3413573 0.572255531,18.5156152 0.900091816,18.5156152 L8.10793012,18.5156152 L5.42728051,28.9048175 C5.31916173,29.3245833 5.53797925,29.7580014 5.94495463,29.9288022 L5.94495463,29.9288022 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icBoosts",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    xlinkHref: "#path-2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBoosts);
export default __webpack_public_path__ + "static/media/icBoosts.11ca157d86a88bd8e966e2353ab1c6a7.svg";
export { ForwardRef as ReactComponent };